import React, { useState } from "react";
import { createPortal } from "react-dom";
import { Menu, X, MessageCircle, TrendingUp } from "lucide-react";
import { navLinks, aff, WHATSAPP_GROUP } from "../mock";

export default function Header() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-40 bg-[#FBF8F4]/95 backdrop-blur border-b border-[#EAE3D8]">
      <div className="container-y grid grid-cols-[1fr_auto_1fr] items-center px-5 md:px-8 h-16 md:h-20">
        <div className="flex items-center justify-start">
          <button
            onClick={() => setOpen(true)}
            className="md:hidden text-[#1a1a1a] -ml-1 p-1"
            aria-label="Menu"
            data-testid="mobile-menu-open-btn"
          >
            <Menu size={24} strokeWidth={1.5} />
          </button>
          <nav className="hidden md:flex items-center justify-end gap-8 w-full pr-10">
            {navLinks.slice(0, 3).map((l) => (
              <a
                key={l.label}
                href={l.href}
                target="_blank"
                rel="noreferrer"
                className="font-sans-y text-[12px] tracking-[0.18em] uppercase text-[#1a1a1a] hover:text-[#C9A961] transition-colors whitespace-nowrap"
              >
                {l.label}
              </a>
            ))}
          </nav>
        </div>

        <a
          href={aff("/")}
          target="_blank"
          rel="noreferrer"
          data-testid="header-logo-link"
          className="font-serif-y text-[26px] md:text-[32px] tracking-[0.35em] text-[#1a1a1a] justify-self-center pl-[0.35em]"
        >
          YBERA
        </a>

        <nav className="hidden md:flex items-center justify-start gap-8 pl-10">
          {navLinks.slice(3).map((l) => (
            <a
              key={l.label}
              href={l.href}
              target="_blank"
              rel="noreferrer"
              className="font-sans-y text-[12px] tracking-[0.18em] uppercase text-[#1a1a1a] hover:text-[#C9A961] transition-colors whitespace-nowrap"
            >
              {l.label}
            </a>
          ))}
        </nav>
      </div>

      {/* Mobile menu */}
      {open && createPortal(
        <div className="fixed inset-0 z-[100] bg-[#FBF8F4] md:hidden menu-fade-in" data-testid="mobile-menu">
          <div className="flex items-center justify-between px-5 h-16 border-b border-[#EAE3D8]">
            <button onClick={() => setOpen(false)} aria-label="Close menu" data-testid="mobile-menu-close-btn" className="-ml-1 p-1"><X size={24} strokeWidth={1.5} /></button>
            <span className="font-serif-y text-[24px] tracking-[0.35em] pl-[0.35em]">YBERA</span>
            <span className="w-8" />
          </div>
          <div className="flex flex-col p-6 gap-5">
            {navLinks.map((l) => (
              <a
                key={l.label}
                href={l.href}
                target="_blank"
                rel="noreferrer"
                className="font-sans-y text-[14px] tracking-[0.15em] uppercase text-[#1a1a1a] border-b border-[#EAE3D8] pb-4"
              >
                {l.label}
              </a>
            ))}

            <a
              href="#affiliate"
              onClick={() => setOpen(false)}
              data-testid="mobile-menu-affiliate-link"
              className="mt-2 inline-flex items-center justify-center gap-2 px-5 py-3.5 bg-[#C9A961] text-[#1a1a1a] font-sans-y text-[13px] tracking-[0.15em] uppercase font-semibold"
            >
              <TrendingUp size={16} /> Become an Affiliate
            </a>
            <a
              href={WHATSAPP_GROUP}
              target="_blank"
              rel="noreferrer"
              onClick={() => setOpen(false)}
              data-testid="mobile-menu-whatsapp-link"
              className="inline-flex items-center justify-center gap-2 px-5 py-3.5 bg-[#25D366] text-white font-sans-y text-[13px] tracking-[0.15em] uppercase font-semibold"
            >
              <MessageCircle size={16} /> WhatsApp Group
            </a>
          </div>
        </div>,
        document.body
      )}
    </header>
  );
}
